import CustomTab from './customTab'
export default CustomTab
